<template>
  <div class="splash-wrapper" :class="{ 'pink-mode': isPink }">
    <div class="splash" :class="{ 'pink-mode': isPink }">

      <img src="@/assets/facedown.jpg" alt="Splash Image" class="splash-img" />

      <div class="message-box">
        <p>It's website time baby</p>
        <p>Now fully automated!</p>
        <p>or is it?</p>
        <h1>Someday I'll livestream the 3D printer feed here</h1>
      </div>

      <div class="links">
        <router-link class="blog-link" to="/blog">Click me? 👉👈</router-link>
      </div>

      <div style="height: 4rem;"></div>

      <!-- Wire up the event from PinoButton.vue -->
      <PinoButton
        :isPink="isPink"
        @toggle-pink="togglePink"
        style="margin-top: 1.5rem;"
      />
      <div style="height: 4rem;"></div>

      <HonnerableMentions />
    </div>
  </div>
</template>

<script>
import HonnerableMentions from "@/components/HonorableMentions.vue";
import PinoButton from "@/components/PinoButton.vue";

export default {
  components: {
    HonnerableMentions,
    PinoButton,
  },
  data() {
    return {
      isPink: false,
    };
  },
  methods: {
    togglePink() {
      this.isPink = !this.isPink;
    },
  },
};
</script>

<style scoped>
.splash-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: black;
  height: 100vh;
  width: 100vw;
  transition: background-color 0.25s ease;
}

.splash-wrapper.pink-mode {
  background-color: hotpink;
}

.splash {
  width: 375px; /* Typical mobile width */
  height: 667px; /* Typical mobile height */
  background-color: black;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  padding: 1rem;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.1);
  transition: background-color 0.25s ease, color 0.25s ease;
}

/* Optional: also tint the "phone screen" panel itself */
.splash.pink-mode {
  background-color: hotpink;
  color: black;
}

.splash-img {
  width: 100%;
  height: auto;
  max-height: 40%;
  object-fit: cover;
}

.message-box {
  margin-top: 1rem;
  font-size: 1rem;
  text-align: center;
}

.links {
  margin-top: 1.5rem;
}

a {
  color: #42b983;
  text-decoration: none;
}

.blog-link {
  color: #2462aa;
  text-decoration: none;
}

/* If you enable splash pink-mode, keep router-link readable */
.splash.pink-mode a .blog-link {
  color: black;
  font-weight: 700;
}
</style>
